import { Page as iPage , Table as iTable } from 'iview'

export { default as TableCell } from './cell'

export const Table = {
  name: 'Table',
  props: {
    columns: {
      default: function() {
        return []
      }
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean
    },

    data: {
      default: function() {
        return []
      }
    },
    selectionKey:{
      default:'id'
    },
    page: {
      default: function() {
        return {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOpts:[10,20,30,40]
        }
      }
    }
  },

  data() {
    return {
      selection: []
    }
  },
  computed:{
    indeterminate(){
      const count = this.selection.length 
      //const fromData = this.data.some( i => i._checked )

      if( count > 0 && count < this.data.length){
        return true
      }else{
        return false
      }
    },
    checked(){
      return this.selection.length > 0 && this.selection.length == this.data.length 
    }
  },
  watch:{
    data(d){
      if(d){
        this.selection = []
      }
    }
  },
  methods: {
    handleSelect(selection) {
      const { selectionKey } = this
      this.selection = selectionKey ? selection.map(i => i[selectionKey]) : selection
      this.$emit('on-selection-change', selection)
    },
    handlePageChange(current) {
      this.$emit('change', {
        current,
        pageSize: this.page.pageSize
      })
      this.$emit('on-update', current, this.page.pageSize)
    },
    handleSizeChange(pageSize) {
      this.$emit('change', {
        current: this.page.pageNum,
        pageSize
      })
      this.$emit('on-update', this.page.pageNum, pageSize)
    },
    handleChangeSort({column, key, order}) {
      this.$emit('on-sort-change', {column, key, order})
      this.$emit('change', null,null,{column, key, order})
    },
    handleFilterchange(obj){
      this.$emit('on-filter-change', obj)
    },
    handleCheckAll(flag) {
      this.$refs['table'].selectAll(flag);
    },
    handleSelectCancel(...rest) {
      this.$emit('on-select-cancel', ...rest)
    },

    renderBatch() {
  
      const { $scopedSlots, indeterminate, selection , handleCheckAll , checked} = this
      if( !$scopedSlots.batch ){
        return null
      }

      const enable = selection.length > 0
      const enableBatch = !!$scopedSlots.batch

      if(enableBatch){
        return <div style="border-bottom: 1px solid #e8eaec;padding-bottom:8px;">
          <div style="width:46px;" class="table-batch-check">
            <Checkbox indeterminate={indeterminate} value={checked} on-on-change={handleCheckAll}></Checkbox>
          </div>
          {$scopedSlots.batch({selection , enable})}
        </div>
      }else{
        return null
      }
      
    }
  },
  render() {
    const { showHeader, loading, columns, data, handleSelect, handleChangeSort, page, handlePageChange, handleSizeChange, renderBatch, handleFilterchange } = this
    const pageEl = page !== false ?
      <iPage style="padding-top: 15px;text-align: right;" total={page.total} current={page.pageNum} page-size={page.pageSize} on-on-change={handlePageChange} page-size-opts={page.pageSizeOpts} on-on-page-size-change={handleSizeChange} size="small" show-total show-elevator show-sizer ></iPage>
      : null
    const batchEl = renderBatch()
    return (
      <div>
        {batchEl}
        <iTable ref="table" show-header={showHeader} loading={loading} columns={columns} data={data} on-on-selection-change={handleSelect} on-on-sort-change={handleChangeSort} on-on-filter-change={handleFilterchange}></iTable>
        {pageEl}
      </div>
    )
  }
}
